const VARIANT = {
    DANGER: "danger",
    SUCCESS: "success",
    WARNING: "warning",
    INFO: "info",
    LINK: "link",
    LIGHT: "light",
    DARK: "dark",
    SECONDARY: "secondary",
    PRIMARY: "primary",
    TRANSPARENT: "transparent",
    UNI: "uni",
    CUSTOM: "custom",
    TABS: "tabs"
}

export default VARIANT;